import { useSelector } from 'react-redux'
import { shouldUseGenericApplianceCopy } from 'utils/statusUtils'

/**
 * True when the currently viewed patient's scans should be described with generalised
 * "device/appliance" wording and iconography instead of naming aligners.
 *
 * Keeps the decision in one place so the scan feed, referrals card, treatment tracker and
 * scan summary cannot disagree with each other -- or with the patient app, which uses the
 * same predicate.
 */
export default () =>
  useSelector(state => {
    const treatment = state.patientsReducer.patient?.treatments?.items?.[0]

    // The update-treatment response carries currentStatus.statusKey but no nested
    // status { type }, and the reducer replaces the treatment wholesale with it. Without
    // this fallback the predicate collapses to "type === Other" after any save, so an
    // Aligners-in-Retention patient silently reverts to aligner wording until reload.
    const statusType = treatment?.currentStatus?.status?.type ?? treatment?.currentStatus?.statusKey?.split('_')?.[0]

    return shouldUseGenericApplianceCopy(treatment && { ...treatment, currentStatus: { status: { type: statusType } } })
  })
